export default __webpack_public_path__ + "static/media/HomeIcon.2c75a1e0.svg";